import track from 'react-tracking';
import ReportSubSection from '@components/ReportSubSection';
import ReportNextSteps from '@components/ReportNextSteps';
import useDividendInvestingIdea from '@/pages/CompanyReport/hooks/useDividendInvestingIdea';
import loadable from '@loadable/component';
import { useVisibleSectionsIsPristine } from '../../../VisibleSectionsContextProvider';

const NextSteps = loadable(
  () => import('@/pages/CompanyReport/components/Overview/components/NextSteps')
);

export interface DividendNextStepsProps {
  countryISO: string;
  industryPrimaryName: string;
}

const DividendNextSteps = ({
  countryISO,
  industryPrimaryName,
}: DividendNextStepsProps) => {
  const payload = useDividendInvestingIdea(countryISO.toLowerCase());
  const isPristine = useVisibleSectionsIsPristine();
  return (
    <ReportSubSection
      titleElement={isPristine ? 'h2' : 'h3'}
      title="Discover strong dividend paying companies"
      body={
        <ReportNextSteps>
          <li>
            {typeof payload !== 'undefined' && (
              <NextSteps
                link={payload.linkToInvestingIdea}
                industry={industryPrimaryName}
                section="dividend"
                market={countryISO}
              />
            )}
          </li>
        </ReportNextSteps>
      }
    />
  );
};

export default track(() => ({
  type: 'track',
  subject: 'DividendNextSteps',
}))(DividendNextSteps);
